import {Button} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {COLORS} from "../../constants/constants";

const StyledButton = styled(Button)`
  padding: 4px 12px;
  border-radius: 8px;
  box-shadow: none !important;
  height: 32px;
  min-width: 32px;
  width: max-content;

  &.bp5-button.bp5-intent-primary:not(.bp5-disabled) {
    background: ${COLORS.BG_GRADIENT_DARK_BLUE};
    color: ${COLORS.WHITE};
  }

  &.bp5-button:not([class*="bp5-intent-"]):not(.bp5-disabled) {
    color: ${COLORS.BLUE};
    background: ${COLORS.BRIGHT_BLUE};
  }

  :hover:not(.bp5-disabled) {
    opacity: 0.95;
  }

  :active:not(.bp5-disabled) {
    opacity: 0.8;
  }
`;

const StyledSelectButton = styled(Button)<{hasValue: boolean}>`
  position: relative;
  background: ${(props) => (props.hasValue ? "#8da4be !important" : "#ffffff !important")};
  color: ${(props) => (props.hasValue ? "#ffffff !important" : "#8DA4BE !important")};
  box-shadow: 0px 1px 1px 0px #00000040 !important;
  padding: 6px 10px 6px 10px !important;
  border-radius: 4px !important;
  white-space: nowrap;
  :hover {
    opacity: 0.8;
    background: ${(props) => (props.hasValue ? "" : " !important")};
  }

  .bp5-button-text {
    display: flex;
    flex-direction: row;
    align-items: end;
    line-height: 18px;
  }

  .bp5-icon {
    color: ${(props) => (props.hasValue ? "#ffffff" : "#8DA4BE")};
  }
`;

const CancelButton = styled(Button)`
  border-radius: 8px;
  color: ${(props) => props.color ?? COLORS.TEXT_BLACK} !important;
`;

export {StyledButton, StyledSelectButton, CancelButton};
